import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DropzoneComponent from "../../../Components/Common/DropzoneComponent";
import ImageForm from "../component/ImageForm";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardImg,
  Col,
  Row,
} from "reactstrap";
import MenuImageService from "../../../Services/QRCodeServices/MenuItem/MenuImageService";
import DeleteModal from "../../CRUD/generalAdmin/DeleteModal";
import toast from "react-hot-toast";
import ViewImage from "../component/ViewImage";

const MenuImage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewOpen, setIsViewOpen] = useState(false);

  const [selectedItem, setSelectedItem] = useState();
  const toggleModal = (item) => {
    setIsModalOpen(!isModalOpen);
    setSelectedItem(item);
  };
  const toggleView = (item) => {
    setIsViewOpen(!isViewOpen);
    setSelectedItem(item);
  };
  const [responseData, setResponseData] = useState([]);
  const fetchData = async () => {
    try {
      const response = await MenuImageService.getList();
      setResponseData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);

  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    toggleDeleteModal();
  };
  const handleDelete = async () => {
    if (selectedItem?.id) {
      try {
        await MenuImageService.delete(selectedItem.id);
        toast.success("Selected item deleted successfully");
        fetchData();
      } catch (error) {
        toast.error("Failed to delete the record");
      } finally {
        toggleDeleteModal();
        setSelectedItem(null);
      }
    }
  };
  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Menu Image List" pageTitle="Menu Image" />
      </div>
      <div className="d-flex justify-content-end align-content-end">
        <button className="btn btn-success mb-3 " onClick={toggleModal}>
          Add Image
        </button>
      </div>

      <Row>
        {responseData?.map((item, index) => (
          <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-4">
            <Card className="h-100" onClick={() => toggleView(item)}>
              <CardHeader>
                <h6 className="mb-0">{item?.name}</h6>
              </CardHeader>

              <CardBody className="d-flex justify-content-center align-items-center">
                <div className="w-100 d-flex justify-content-center">
                  <img
                    src={item?.cloudR2Path?.getCDNUrl()}
                    alt={item?.name}
                    className="img-fluid object-fit-contain"
                    style={{
                      height: "200px", // 👈 fixed height for uniformity
                      width: "100%",
                    }}
                  />
                </div>
              </CardBody>

              <CardFooter>
                <ButtonGroup className="gap-3">
                  <Button
                    color="warning"
                    className="rounded-circle btn-sm d-flex align-items-center justify-content-center"
                    style={{ width: "30px", height: "30px" }}
                    onClick={(e) => {
                      e.stopPropagation(); // stop the click from bubbling up
                      toggleModal(item); // open your modal
                    }}
                  >
                    <i className="bx bx-edit"></i>
                  </Button>
                  <Button
                    color="danger"
                    className="rounded-circle btn-sm d-flex align-items-center justify-content-center"
                    style={{ width: "30px", height: "30px" }}
                    onClick={(e) => {
                      e.stopPropagation(); // stop the click from bubbling up
                      handleDeleteClick(item);
                    }}
                  >
                    <i className="bx bx-trash"></i>
                  </Button>
                </ButtonGroup>
              </CardFooter>
            </Card>
          </Col>
        ))}
      </Row>

      <ImageForm
        isOpen={isModalOpen}
        toggle={toggleModal}
        selectedItem={selectedItem}
        fetchData={fetchData}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedItem}
      />

      <ViewImage
        isOpen={isViewOpen}
        toggle={toggleView}
        selectedItem={selectedItem}
      />
    </div>
  );
};

export default MenuImage;
